import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Headshot from "../components/Headshot"
import Map from "../components/Map"

import JustinHeadshot from "../../static/images/justinFace.jpg"
import MeganHeadshot from "../../static/images/meganFace.jpg"

const Homepage = ({ location }) => {
  const siteTitle = "Shockley + Ryan = Shryan"

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="Megan And Justin Are Getting Married" />
      <div className="banner-container">
        <h1 className="banner-text">We're getting married!</h1>
        <div className="banner-info">
          <h3>June 26, 2021</h3>
          <p>966 Cooper St #5611</p>
          <p>Memphis, TN</p>
        </div>
      </div>
      <div className="main-content">
        <div className="headshot-container">
          <Headshot
            image={JustinHeadshot}
            alt={"Justin Shockley head shot"}
            name={"Justin Shockley"}
          />
          <Headshot
            image={MeganHeadshot}
            alt={"Megan Ryan head shot"}
            name={"Megan Ryan"}
          />
        </div>
        <div id="main">
          <p>
            We met in Midtown, Memphis. Then four months later I (Megan) decided I 
            would move to Japan, and we decided to "keep whatever this was going, 
            and we'd just see". Now, three years later we decided we'd keep it going 
            a little bit longer and get married.
          </p>
          <p> 
            We're having a private ceremony, 
            and we'd love if you'd join us a couple days later for a celebration of 
            love and partnership! Things have changed well all over the place as we've 
            been planning. So, we've decided to keep it small and enjoy the ones who've 
            truly impacted our lives or partnership in some way. There's going to be 
            dining, sippin, and dancing and we'd really like you there!
          </p>
        </div>
        <div id="directions">
          <div id="directions-header">
            <h3 className="section-header-text">Directions</h3>
          </div>
          <div className="map-container">
            <div className="directions">
              <p>
                Our wedding will be at the Beauty Shop in the Cooper Young district 
                of Midtown Memphis.
              </p>
            </div>
            <Map />
          </div>
        </div>
        <div id="faq">
          <div id="faq-header">
            <h3 className="section-header-text">FAQ</h3>
          </div>
          <div className="faq">
            <p>
              <strong>What should I wear?</strong>
            </p>
            <ul>
              <li>
                This is a Studio54 inspired reception. Pull out your favorite
                disco chic inspired look. Make it something fun and even a
                little kitchie!
              </li>
            </ul>
          </div>
          <div className="faq">
            <p>
              <strong>Can I bring my children?</strong>
            </p>
            <ul>
              <li>
                Yes, you may. We understand that sometimes child care isn't the
                easiest to come by. With that said, please understand this is a
                Saturday night and an adult forward event. We encourage you to
                make the best decision for you and we want you to have the most
                relaxing evening where you can kick back and let loose!
              </li>
            </ul>
          </div>
          <div className="faq">
            <p>
              <strong>
                For out of town guests: We love that you're coming all this way
                to celebrate our marriage!
              </strong>
            </p>
            <ul>
              <li>
                <strong>Here our some ideas on where to stay:</strong>
                <ul>
                  <li>Arrive Memphis</li>
                  <li>The Central Station</li>
                  <li>Memphis Pettigrew Adventures</li>
                </ul>
              </li>
              <li>
                <strong>Places we love to eat in Memphis:</strong>
                <ul>
                  <li>Pho Binh (vietnamese)</li>
                  <li>Slider Inn (divey bar with a great patio and sliders)</li>
                  <li>Payne's BBQ</li>
                  <li>Gus's Fried Chicken</li>
                  <li>Kwik Check</li>
                </ul>
              </li>
              <li>
                <strong>Places we love to get coffee:</strong>
                <ul>
                  <li>City & State</li>
                  <li>Bell Tower</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div id="registry">
          <div id="registry-header">
            <h3 className="section-header-text">Registry & Gifts</h3>
          </div>
          <p>
            We have more than enough items in our home. We would love to take a
            honeymoon to Italy, which is a country we'd really like to check off
            our bucket list. We both love to travel and would love to spend a
            week eating to our hearts content and spending time basking in the
            beauty of Italy. We also have a deep commitment of supporting
            non-profits that are committed to enacting real change in our
            community, so we will be taking 10% of gifts received and donating
            them to various non-profit organizations.
          </p>
          <div style={{ width: "200px", margin: "0 auto" }}>
            <a
              href="http://www.honeyfund.com/wedding/ryan-shockley-06-26-2021"
              style={{
                textAlign: "left",
                background:
                  "url('http://www.honeyfund.com/share/honeyfund3.png') no-repeat",
                display: "block",
                width: "200px",
                height: "100px",
                textIndent: "-9999em",
              }}
            >
              Visit our honeyfund at Honeyfund.com, the free honeymoon registry
            </a>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Homepage


